import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "panel", "valuationsList"]
  static values = {
    delay: { type: Number, default: 800 },
    searchUrl: { type: String, default: "/nova/search" },
    minLength: { type: Number, default: 3 }
  }

  connect() {
    this.timeoutId = null
    this.currentQuery = ""
    this.currentPage = 1
    this.boundHandleClickOutside = this.handleClickOutside.bind(this);
  }

  disconnect() {
    if (this.timeoutId) clearTimeout(this.timeoutId)
  }

  onInput(event) {
    if (event.key === 'Enter') {
      this.performSearch()
      return
    }

    if (this.timeoutId) clearTimeout(this.timeoutId)

    const query = this.inputTarget.value.trim()

    if (query === "") {
      this.hidePanel()
      return
    }

    if (query.length < this.minLengthValue) {
      this.showMinLengthMessage()
      return
    }

    this.timeoutId = setTimeout(() => {
      this.performSearch()
    }, this.delayValue)
  }

  async performSearch(page = 1) {
    const query = this.inputTarget.value.trim()

    if (query.length < this.minLengthValue) {
      return
    }

    this.currentQuery = query
    this.currentPage = page

    try {
      const params = new URLSearchParams({
        q: query,
        page: page
      })

      const response = await fetch(`${this.searchUrlValue}?${params}`, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (response.ok) {
        const html = await response.text()
        this.panelTarget.innerHTML = html
        this.showPanel()
      }
    } catch (error) {
      console.error('Search error:', error)
    }
  }

  async loadMore(event) {
    const nextPage = parseInt(event.params.nextPage)
    const query = this.currentQuery

    try {
      const params = new URLSearchParams({
        q: query,
        page: nextPage
      })

      const response = await fetch(`${this.searchUrlValue}?${params}`, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (response.ok) {
        const html = await response.text()
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = html

        const newValuations = tempDiv.querySelector('[data-search-results-target="valuationsList"]')
        if (newValuations && this.hasValuationsListTarget) {
          this.valuationsListTarget.insertAdjacentHTML('beforeend', newValuations.innerHTML)
        }

        const loadMoreButton = event.target.closest('.px-12.pt-6.pb-10')
        if (loadMoreButton) {
          const newLoadMoreSection = tempDiv.querySelector('.px-12.pt-6.pb-10')
          if (newLoadMoreSection) {
            loadMoreButton.replaceWith(newLoadMoreSection)
          } else {
            loadMoreButton.remove()
          }
        }

        this.currentPage = nextPage
      }
    } catch (error) {
      console.error('Load more error:', error)
    }
  }

  showPanel() {
    this.panelTarget.classList.remove("hidden")
    document.addEventListener('click', this.boundHandleClickOutside);
  }

  hidePanel() {
    this.panelTarget.classList.add("hidden")
    document.removeEventListener('click', this.boundHandleClickOutside);
  }

  showMinLengthMessage() {
    const messageHtml = `
      <div class="px-14 py-20 text-center">
        <p class="text-paragraph-s text-black-400">Type at least ${this.minLengthValue} characters to search</p>
      </div>
    `
    this.panelTarget.innerHTML = messageHtml
    this.showPanel()
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hidePanel()
    }
  }
}
